import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import { FormikProps, FormikValues } from 'formik';
import { camelCase } from 'lodash';
import React from 'react';

import { StepperFormStepType } from '../StepperForm.types';
import { StepperFormBackButton } from './StepperFormBackButton';

interface Props extends Omit<BoxProps, 'onSubmit'> {
  activeStepIndex: number;
  formikState: FormikProps<FormikValues>;
  isLinear: boolean;
  isMobile: boolean;
  onBack: (index: number) => void;
  steps: StepperFormStepType[];
}

export const StepperFormStep: React.FC<Props> = ({
  activeStepIndex,
  formikState,
  isLinear,
  isMobile,
  onBack,
  steps,
  ...boxProps
}) => {
  const { component: StepComponent, title } = steps[activeStepIndex];

  return (
    <Box
      {...boxProps}
      aria-label="step"
      data-testid={`step-${camelCase(title)}`}
    >
      <Flex alignItems="center" marginBottom={6}>
        {isLinear && isMobile && (
          <StepperFormBackButton
            activeStepIndex={activeStepIndex}
            aria-label="Back to previous step"
            marginRight={2}
            onClick={onBack}
          />
        )}

        <Box
          marginRight={2}
          boxSize={6}
          borderRadius={9999}
          backgroundColor="neutral.800"
          color="white"
          fontSize="xs"
          fontWeight={400}
          textAlign="center"
          lineHeight={6}
        >
          {activeStepIndex + 1}
        </Box>

        <Text data-testid="step-title" fontSize="lg" fontWeight={400}>
          {title}
        </Text>
      </Flex>

      <StepComponent {...formikState} />
    </Box>
  );
};
